import React from "react";
import { colors, displayName } from "../utils/theme.js";

export const initialsOf = (u) =>
  u ? ((u.firstName?.[0] || "") + (u.lastName?.[0] || "")).toUpperCase() || (u.name || "?").slice(0, 2).toUpperCase() : "?";

// A staff member's profile photo (initials fallback), optionally followed by their name.
// `label` overrides the shown name (e.g. a raw id when the user record is unknown).
export default function UserAvatar({ user, size = 20, showName = false, label, maxNameWidth = 110 }) {
  const name = label ?? (user ? displayName(user) : "");
  return (
    <span style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }} title={name}>
      {user?.photo
        ? <img src={user.photo} alt="" style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
        : <span style={{ width: size, height: size, borderRadius: "50%", background: colors.surfaceAlt, color: colors.textMuted, fontSize: Math.round(size * 0.45), fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{initialsOf(user)}</span>}
      {showName && <span style={{ fontSize: 11, color: colors.textMuted, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: maxNameWidth }}>{name}</span>}
    </span>
  );
}
